export default __webpack_public_path__ + "static/media/sticker-M.0e822250.png";